import type {StateProvider} from '@uirouter/angularjs';
import ReportServerController from './report-server.controller';
import type ReportServerService from './report-server.service';

/*@ngInject*/
export default function reportServerRoutes($stateProvider: StateProvider) {

    $stateProvider
        .state({
            name: 'report-server',
            url: '/report-server',
            templateUrl: require('./report-server.tpl.ftl'),
            controller: ReportServerController,
            controllerAs: 'reportServerCtrl',
            resolve: {
                /*@ngInject*/
                serverFolder: (reportServerService: ReportServerService) => ReportServerController.getServerFolder(reportServerService)
            }
        });
}
